module.exports = __webpack_public_path__ + "static/media/sm2.65674fc0.png";